// Lib
import { createAction } from 'redux-actions';

export const PWAInstall = createAction('PWA_INSTALL');
